/* Legacy code - ignore this errors */
/* eslint class-methods-use-this: 0 */
import React from 'react';
import Flexbox from 'flexbox-react';
import { observable } from 'mobx';
import { observer, Provider } from 'mobx-react';
import {
  Popover,
  Position,
  PopoverInteractionKind,
  Tag,
  AnchorButton,
  Alert,
  Intent,
  Classes,
} from '@blueprintjs/core';
import CurrentUserStore from '../../stores/CurrentUserStore';
import DashboardStore from '../../stores/DashboardStore';
import DynamicViewStore from '../../stores/DynamicViewStore';
import AppStore from '../../stores/AppStore';
import AppItemStore from '../../stores/AppItemStore';
import UserProfileStore from '../../stores/UserProfileStore';
import UserProfileTemplateStore from '../../stores/UserProfileTemplateStore';
import ToastStore from '../../stores/ToastStore';
import ItemStore from '../../stores/ItemStore';
import ItemActions from '../../actions/ItemActions';
import TemplateActions from '../../actions/TemplateActions';
import TeamUsersStore from '../../stores/TeamUsersStore';
import NotificationStore from '../../stores/NotificationStore';
import WorkspaceStore from '../../stores/WorkspaceStore';
import ThemeWrapper from '../styles/ThemeWrapper/index.js';
import ErrorBoundary from '../errors/ErrorBoundary';
import Avatar from 'react-avatar';
import Utilities from '../../utils/Utilities';
import AccountPopover from './AccountPopover';
import WorkspaceMenuList from './WorkspaceMenuList';
import AccountSwitchingMenu from '../accounts/AccountSwitchingMenu';
import QuickCreate from './QuickCreate';
import _ from 'lodash';
import GoalPopover from './GoalPopover';
import Feedback360SettingsPopover from './Feedback360SettingsPopover';
import PerformancePopover from './PerformancePopover';
import axios from 'axios';
import Cookies from 'js-cookie';
import GoalCycle from '../../assets/GoalCycle.svg';
import TeamReview from '../../assets/TeamReview.svg';
import OnboardingSettingsIcon from '../../assets/OnboardingSettingsIcon.svg';
import OnboardingProcessIcon from '../../assets/OnboardingProcess.svg';
import ReportPopover from './ReportPopover';

const PROPROFS_USERS_TO_SWITCH_ACCOUNT = [
  '83657cbc-bbbf-4842-bfb3-54dd2e897a85',
  '1a954316-17e3-4968-8608-50a634edd286',
  '5cabf056-bcb3-4fbb-94ee-852ddcc63450',
  '4c711ec7-dbfe-4873-85b8-7b66c4130e8a',
  '769f1c09-c452-4b2e-98ee-725852cc0244',
];

@observer
export default class Sidebar extends React.Component {
  @observable isLoading = true;
  @observable showAlert = false;

  constructor(props) {
    super(props);
    this.state = {
      isManager: false,
      showGoal: false,
      isOrganizationStructuresEligible: false,
    }
  }

  componentDidMount() {
    this.fetchIsShowGoal().then(() => {
      if (this.state.showGoal) {
        this.fetchIsManagerAccount();
      }
    });

    this.fetchOrganizationStructuresAccess();

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
      (function() {
        var pp = document.createElement('script'),
            ppr = document.getElementsByTagName('script')[0];
        stid = 'ZW4xN2tSeGhqSzJWMGNiR3VvR0tIUT09';
        pp.type = 'text/javascript';
        pp.async = true;
        pp.src = (document.location.protocol === 'https:' ? 'https://' : 'http://') + 
                 's01.live2support.com/dashboardv2/chatwindow/';
        ppr.parentNode.insertBefore(pp, ppr);
      })();
    `;
    document.body.appendChild(script);
  }

  toggleLoading = () => {
    this.isLoading = !this.isLoading;
  };

  toggleAlert = () => {
    this.showAlert = !this.showAlert;
  };

  handleLeaveAccount() {
    CurrentUserStore.leaveCurrentAccount().then(response => {
      this.showAlert = false;
      Utilities.navigate('/setup');
    });
  }

  fetchIsManagerAccount = () => {
    axios
      .get(`${Cookies.get('apiEnv')}/goals/employee_exists`)
      .then(response => {
        this.setState({ isManager: response.data.exists });
      })
      .catch(error => { });
  };

  fetchIsShowGoal = () => {
    return axios
      .get(`${Cookies.get('apiEnv')}/goals/smart_goals_access`)
      .then(response => {
        this.setState({
          showGoal: response.data.is_eligible,
        });
      })
      .catch(error => { });
  };

  fetchOrganizationStructuresAccess = () => {
    return axios
      .get(`${Cookies.get("apiEnv")}/organization_structures/organization_structures_access`)
      .then(response => {
        this.setState({
          isOrganizationStructuresEligible: response.data?.is_eligible === true
        });
      })
      .catch(() => {
        this.setState({
          isOrganizationStructuresEligible: false
        });
      });
  };

  renderAccountIcon() {
    const accountImage = CurrentUserStore.activeAccount.accountImage;

    return (
      <Avatar
        src={accountImage}
        className="bp3-cursor-pointer bp3-sidebar-logo"
        round={true}
        size={50}
      />
    );
  }

  render() {
    const stores = {
      CurrentUserStore,
      DashboardStore,
      DynamicViewStore,
      UserProfileStore,
      UserProfileTemplateStore,
      AppStore,
      AppItemStore,
      ItemStore,
      ItemActions,
      ToastStore,
      TemplateActions,
      TeamUsersStore,
      NotificationStore,
      WorkspaceStore,
    };

    const hasAccount = CurrentUserStore
      ? CurrentUserStore.currentUser.accountId.length > 0
      : false;
    // const showGoals = ['1f9e60ed-2128-43ee-8f32-15e20f810bad','6804890a-3257-46ed-a84a-d6ac156b0573','e9570019-f65a-40f9-838a-b2e31754f6ed','9d1a158a-4d9e-4f3a-b8a2-dd0d2f82a66d'].includes(CurrentUserStore.activeAccount.accountId)
    const {
      activeAccount,
      authorizedAccounts,
      userSignedIn,
      userIsAccountOwner,
      isLoading,
      showNewGoals,
      currentUser,
    } = CurrentUserStore;
    // Special handling: for these account IDs, only account owners should see Teams/Organization.
    // For all other accounts, Teams/Organization should be visible to everyone.
    const SPECIAL_ACCOUNT_IDS = ['5b21d7fd-dd1f-4fc8-a67c-d40f61286d7f'];
    const isAccountOwner =
      Boolean(userIsAccountOwner) ||
      Boolean(CurrentUserStore.currentUser?.isAccountOwner) ||
      Boolean(activeAccount?.accountOwner);
    let showTeamsOrg = true;
    if (SPECIAL_ACCOUNT_IDS.includes(activeAccount?.accountId)) {
      // for the special account(s), require owner to show modules
      showTeamsOrg = Boolean(isAccountOwner);
    }
    const hideTeamsOrg = !showTeamsOrg;
    const { action, activeObjectId } = this.props;
    const visibleAccounts = authorizedAccounts.filter(account => {
      if (account.activeAccount) return false;

      const isSmartToolsAccount =
        account.accountId === '06dc188c-1ef7-4eea-ace3-b7366ec03947';
      if (
        isSmartToolsAccount &&
        !PROPROFS_USERS_TO_SWITCH_ACCOUNT.includes(currentUser?.id)
      ) {
        return false;
      }

      return true;
    });

    if (isLoading) {
      return (
        <ErrorBoundary>
          <Provider {...stores}>
            <ThemeWrapper>
              <Flexbox
                flexGrow={1}
                flexDirection="column"
                justifyContent="space-between"
                height="100vh"
              >
                <Flexbox
                  flexDirection="column"
                  paddingTop="40px"
                  alignItems="center"
                  flexGrow={1}
                ></Flexbox>
                <Flexbox
                  flexDirection="column"
                  paddingBottom="20px"
                  justifyContent="center"
                  alignItems="center"
                  flexGrow={0}
                ></Flexbox>
              </Flexbox>
            </ThemeWrapper>
          </Provider>
        </ErrorBoundary>
      );
    }
    return (
      <ErrorBoundary>
        <Provider {...stores}>
          <ThemeWrapper>
            <Flexbox
              flexGrow={1}
              flexDirection="column"
              height="100vh"
            >
              <Alert
                portalContainer={document.body}
                isOpen={this.showAlert}
                cancelButtonText={I18n.t('js.cancel')}
                onCancel={this.toggleAlert.bind(this)}
                confirmButtonText={I18n.t('js.leave_active_account', {
                  accountName: activeAccount.accountName,
                })}
                onConfirm={this.handleLeaveAccount.bind(this)}
                intent={Intent.DANGER}
              >
                <h4 className={Classes.HEADING}>
                  {I18n.t('js.are_you_sure')}
                </h4>
                {I18n.t(
                  'js.are_you_sure_you_wish_to_leave_this_account',
                  {
                    accountName: activeAccount.accountName,
                  }
                )}
              </Alert>
              <Flexbox
                flexGrow={1}
                flexDirection="column"
                className="sidebar-scroll-container"
              >
                <Flexbox
                  flexDirection="column"
                  alignItems="stretch"
                  flexGrow={0}
                  className="sidebar-list"
                  marginTop="20px"
                  width="100%"
                >
                  <React.Fragment>
                    <Flexbox width="100%" alignItems="stretch">
                      <Popover
                        portalContainer={document.body}
                        content={
                          visibleAccounts.length > 0 ? (
                            <AccountSwitchingMenu
                              toggleAlert={() => this.toggleAlert()}
                            />
                          ) : null
                        }
                        // content={
                        //   authorizedAccounts.length > 1 ? (
                        //     <AccountSwitchingMenu toggleAlert={() => this.toggleAlert()} />
                        //   ) : null
                        // }
                        interactionKind={PopoverInteractionKind.HOVER}
                        position={Position.RIGHT}
                        boundary="viewport"
                        popoverClassName="sidebar-submenu-popover"
                        modifiers={{
                          offset: {
                            enabled: true,
                            offset: '-14px, 0',
                          },
                        }}
                      >
                        <AnchorButton
                          className="bp3-minimal bp3-account-button"
                          text={activeAccount.accountName}
                          icon={this.renderAccountIcon()}
                          rightIcon="chevron-right"
                        />
                      </Popover>
                    </Flexbox>
                    <AnchorButton
                      className="bp3-minimal bp3-sidebar-button push-20-t"
                      active={action === 'dashboard'}
                      onClick={() => Utilities.navigate(`/dashboard`)}
                      href="/dashboard"
                      text={I18n.t('js.dashboard')}
                      icon="home"
                    />
                    <AnchorButton
                      className="bp3-minimal bp3-sidebar-button"
                      active={
                        action === 'workspaces' &&
                        activeObjectId === null
                      }
                      onClick={() =>
                        Utilities.navigate(`/workspaces`)
                      }
                      href="/workspaces"
                      text={I18n.t('js.workspaces')}
                      icon="grid-view"
                    />
                    <WorkspaceMenuList
                      action={action}
                      activeObjectId={activeObjectId}
                    />
                    {hasAccount && (
                      <>
                        {this.state.showGoal && userIsAccountOwner && (
                          <AnchorButton
                            className="bp3-minimal bp3-sidebar-button"
                            active={
                              action === 'onboarding_settings' &&
                              activeObjectId === null
                            }
                            onClick={() =>
                              Utilities.navigate(`/onboarding/settings`)
                            }
                            href="/onboarding/settings"
                            text={'Check-in Settings'}
                            icon={
                              <img
                                src={OnboardingSettingsIcon}
                                alt="Onboarding Settings Icon"
                                className="sidebar-custom-icon"
                              />
                            }
                          />
                        )}
                        {this.state.showGoal && (
                          <AnchorButton
                            className="bp3-minimal bp3-sidebar-button"
                            active={
                              action === 'onboarding_process' &&
                              activeObjectId === null
                            }
                            onClick={() =>
                              Utilities.navigate(`/onboarding/process`)
                            }
                            href="/onboarding/process"
                            text={'Check-in Process'}
                            icon={
                              <img
                                src={OnboardingProcessIcon}
                                alt="Onboarding Process Icon"
                                className="sidebar-custom-icon"
                              />
                            }
                          />
                        )}
                      </>
                    )}
                    {hasAccount && this.state.showGoal && userIsAccountOwner && (
                      <Feedback360SettingsPopover
                        controller={this.props.controller}
                        action={action}
                        userIsAccountOwner={userIsAccountOwner}
                        account={CurrentUserStore.activeAccount}
                        isManager={this.state.isManager}
                      />
                    )}
                    {hasAccount && this.state.showGoal && (
                      <AnchorButton
                        className="bp3-minimal bp3-sidebar-button"
                        active={action === '360_feedback_form' || action === 'review_360'}
                        onClick={() => Utilities.navigate(`/360_feedback/submission`)}
                        href="/360_feedback/submission"
                        text={'Feedback Forms'}
                        icon={<img src={TeamReview} alt="Feedback Forms Icon" className="sidebar-custom-icon" />}
                      />
                    )}
                    {hasAccount && (
                      <>
                        {this.state.showGoal &&
                          userIsAccountOwner && (
                            <AnchorButton
                              className="bp3-minimal bp3-sidebar-button"
                              active={action === 'goal_settings'}
                              onClick={() =>
                                Utilities.navigate(`/goals/settings`)
                              }
                              href="/goals/settings"
                              text={'Goal Cycle'}
                              icon={
                                <img
                                  src={GoalCycle}
                                  alt="Goal Cycle Icon"
                                  className="sidebar-custom-icon"
                                />
                              }
                            ></AnchorButton>
                          )}
                        {this.state.showGoal && (
                          <GoalPopover
                            controller={this.props.controller}
                            action={action}
                            userIsAccountOwner={userIsAccountOwner}
                            account={CurrentUserStore.activeAccount}
                            isManager={this.state.isManager}
                          />
                        )}
                        {this.state.showGoal && (
                          <AnchorButton
                            className="bp3-minimal bp3-sidebar-button"
                            active={action === 'myassessment'}
                            onClick={() => Utilities.navigate(`/performance/myassessment`)}
                            href="/performance/myassessment"
                            text={'My Performance'}
                            icon="timeline-line-chart"
                          />

                        )}
                      </>
                    )}
                    <Flexbox
                      width="100%"
                      flexDirection="column"
                      paddingTop="0px"
                      paddingBottom="0px"
                    >
                      <div className="bp3-sidebar-divider"></div>
                    </Flexbox>
                  </React.Fragment>
                </Flexbox>
                <Flexbox
                  flexDirection="column"
                  alignItems="stretch"
                  flexGrow={0}
                  className="sidebar-list"
                  width="100%"
                >
                  <React.Fragment>
                    {!hasAccount ? (
                      <div></div>
                    ) : (
                      <React.Fragment>
                        {!hideTeamsOrg && (
                          <>
                            <AnchorButton
                              className="bp3-minimal bp3-sidebar-button"
                              active={action === 'teams'}
                              onClick={() => Utilities.navigate(`/teams`)}
                              href="/teams"
                              icon="layout-hierarchy"
                              text={I18n.t('js.teams')}
                            ></AnchorButton>
                            {this.state.isOrganizationStructuresEligible ? (
                              <AnchorButton
                                className="bp3-minimal bp3-sidebar-button"
                                active={action === 'organization_new_organisation'}
                                onClick={() => Utilities.navigate('/organizations')}
                                href="/organizations"
                                text={I18n.t('js.new_organisation')}
                                icon="send-to-graph"
                              />
                            ) : (
                              <AnchorButton
                                className="bp3-minimal bp3-sidebar-button"
                                active={action === 'organization'}
                                onClick={() => Utilities.navigate('/organization')}
                                href="/organization"
                                text={I18n.t('js.organization')}
                                icon="send-to-graph"
                              />
                            )}
                          </>
                        )}

                        <ReportPopover controller={this.props.controller} action={action} isManager={this.state.isManager} userIsAccountOwner={userIsAccountOwner} showGoal={this.state.showGoal} />
                        <AccountPopover controller={this.props.controller} action={action} userIsAccountOwner={userIsAccountOwner} account={CurrentUserStore.activeAccount} />

                      </React.Fragment>
                    )}
                  </React.Fragment>
                </Flexbox>
              </Flexbox>
              <Flexbox
                flexDirection="column"
                flexGrow={0}
                justifyContent="flex-end"
              >
                <Flexbox
                  onClick={() =>
                    Utilities.navigate('https://www.peoplegoal.com')
                  }
                  className="bp3-cursor-pointer"
                  flexDirection="row"
                  justifyContent="center"
                  paddingBottom="20px"
                >
                  {CurrentUserStore.currentUser.theme == 'dark' ? (
                    <img
                      alt="logo"
                      src={I18n.t(`js.pg_logo_white`)}
                      className="copyright-img-logo"
                    />
                  ) : (
                    <img
                      alt="logo"
                      src={I18n.t(`js.pg_logo_black`)}
                      className="copyright-img-logo"
                    />
                  )}
                </Flexbox>
              </Flexbox>
            </Flexbox>
          </ThemeWrapper>
        </Provider>
      </ErrorBoundary>
    );
  }
}
